import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';

export type ConfirmActionDialogProps = {
  title: string;
  description: string;
  okText?: string;
  cancelText?: string;
  onConfirm: () => void;
  children: React.ReactElement<{ onClick?: (e: React.MouseEvent) => void }>;
};

/** MUI replacement for antd Popconfirm: wraps a single clickable child; opens a confirm dialog on click. */
export const ConfirmActionDialog = ({
  title,
  description,
  okText = 'Yes',
  cancelText = 'No',
  onConfirm,
  children
}: ConfirmActionDialogProps) => {
  const [open, setOpen] = useState(false);

  const trigger = React.cloneElement(children, {
    onClick: (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      setOpen(true);
    }
  });

  return (
    <>
      {trigger}
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{description}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>{cancelText}</Button>
          <Button
            variant="contained"
            autoFocus
            onClick={() => {
              onConfirm();
              setOpen(false);
            }}>
            {okText}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
